<template>
  <AlcoholSelector :currentAlcohols="lotsAlcohols" icon="drinkstart"
    >Hvor mye drikker du når du drikker mye?
    <template v-slot:subheader>
      Tenk på en typisk kveld der du drikker mye (altså mye for å være deg).
      Velg først type drikk, og så styrke, mengde og antall glass.
    </template></AlcoholSelector
  >
</template>

<script>
import AlcoholSelector from "../common/AlcoholSelector";

export default {
  data() {
    return {};
  },
  components: {
    AlcoholSelector: AlcoholSelector,
  },
  computed: {
    lotsAlcohols: {
      get() {
        return this.$store.state.lotsAlcohols;
      },
      set(value) {
        this.$store.commit("setLotsAlcohols", {
          lotsAlcohols: value,
        });
      },
    },
  },
};
</script>

<style lang="scss"></style>
